/**
 * Singleton para el MultiFactorResolver de Firebase.
 *
 * Cuando signInWithEmailAndPassword lanza `auth/multi-factor-auth-required`,
 * el error trae un resolver que se necesita para completar el sign-in con
 * el código TOTP (`resolver.resolveSignIn(assertion)`). El resolver NO es
 * serializable, así que no puede vivir en Redux (el reducer authenticate
 * solo guarda los hints legibles). Se guarda aquí y se consume desde el
 * modal de verificación TOTP.
 */

let _resolver = null;

export const setMfaResolver = (resolver) => { _resolver = resolver; };
export const getMfaResolver = () => _resolver;
export const clearMfaResolver = () => { _resolver = null; };
